import React from 'react'
import CommonSection from "../components/UI/CommonSection";
import Helmet from "../components/Helmet/Helmet";

function Careers() {
  return (
    <Helmet title="Careers">
    <CommonSection title="Careers" />
    <h1 className='text-center text-4xl py-20'>Currently we have no careers available!</h1>
    <p className='text-center text-lg font-semi mb-11'>Always check our social pages and our websites for updates!</p>
    </Helmet>
  )
}

export default Careers